var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"allContent"},[_c('router-view'),_c('NoticeDialogCenter',{attrs:{"uid":_vm.uid,"title":_vm.title,"content":_vm.content,"severity":_vm.severity},model:{value:(_vm.alertFlag),callback:function ($$v) {_vm.alertFlag=$$v},expression:"alertFlag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }